//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { EthAddr } from '@shared/SchemaTypes'
import React, { CSSProperties, ReactElement } from 'react'

import { urlForFile } from '@react/apx/AwsApx'
import { logOT } from '@shared/loggingShared'

import { useOtChainState } from '@react/redux/store'

export default function ViewLogo(props: { poolAddr: EthAddr; style?: CSSProperties }): ReactElement {
  const { poolAddr } = props

  const {
    stageConfiguration: { stageName },
  } = useOtChainState()

  const [noLogo, setNoLogo] = React.useState<boolean>(false)

  const handleError = (): void => {
    logOT.trace('LOGO ERROR', poolAddr)
    setNoLogo(true)
  }

  if (!noLogo && stageName) {
    const url = urlForFile(stageName, `${poolAddr}/logo.png`)
    return <img src={url} style={props.style} onError={handleError} alt={poolAddr} />
  } else {
    return <div style={props.style}></div>
  }
}
